module.exports = __webpack_public_path__ + "static/media/img009.28d67e0e.jpg";